import React, { useState, useRef, useEffect } from "react";
import styles from "./CareerBackgroundUpdate.module.css";
import { Header, Footer, useConfirm } from "@/components";
import { AxiosForm } from "@/Axios";
import { useNavigate, useParams } from "react-router-dom";
import { decoded } from "@/utils";
import {
  useLoadReset,
  useDebouncedCallback,
  useDimLoading,
  useDimLoadComplete,
} from "@hooks";

export default function CareerBackgroundUpdate() {
  const dimLoading = useDimLoading();
  const dimLoadComplete = useDimLoadComplete();
  const loadReset = useLoadReset();
  const { images } = useParams();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const defaultState = {
    imageFile: [],
    preview: [],
    hasImage: false,
  };
  const [state, setState] = useState(defaultState);
  const resetState = () => {
    [...state.preview].forEach((p) => URL.revokeObjectURL(p));
    setState(defaultState);
    loadReset();
  };
  const fileRef = useRef();

  const triggerFileInput = () => {
    if (!state.preview[0]) {
      fileRef.current.click();
    }
  };
  const fileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files[0]) {
      setState((s) => ({
        ...s,
        imageFile: [...files],
        preview: [...files].map((f) => URL.createObjectURL(f)),
        hasImage: true,
      }));
    }
    // 파일 선택 후 초기화
    e.target.value = "";
  };
  const removeImage = () => {
    setState((s) => ({ ...s, imageFile: [], preview: [] }));
  };
  const upsert = useDebouncedCallback(() => {
    if (state.imageFile?.length < 1) {
      confirm("이미지를 등록해주세요");
      return;
    }

    const formData = new FormData();
    if (state.hasImage) {
      [...state.imageFile].forEach((file) =>
        formData.append("imageFile", file)
      );
    }
    formData.append("hasImage", state.hasImage);

    dimLoading();
    AxiosForm.post("/api/career-background/upsert", formData).then((res) => {
      if (res.data?.errMsg) {
        dimLoadComplete(() => {
          confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        });
        return;
      }
      dimLoadComplete(() => {
        confirm(
          `이력 수정이 완료되었습니다.\n확인을 누르면 이력 페이지로 이동합니다.`,
          () => {
            navigate(`/career-background`, {
              replace: true,
            });
          }
        );
      });
    });
  });

  useEffect(() => {
    const data = decoded(images, true);
    setState((s) => ({
      ...s,
      imageFile: data?.length > 0 ? [...data] : [],
      preview: data?.length > 0 ? [...data] : [],
    }));
    return resetState;
  }, []);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <Header title={"이력 수정"} isShare={false} />
        <div className={styles.infoInputArea}>
          <div className={styles.mainImage}>
            <div className={styles.mainImageContainer}>
              <div className={styles.starIcon1} />
              <div
                className={styles.mainImageInputArea}
                onClick={triggerFileInput}
              >
                <div className={styles.inputPlaceholder}>
                  {state.preview.length === 0 && (
                    <span className={styles.mainImageMessage}>
                      PNG 파일을 업로드해주세요
                    </span>
                  )}
                  {state.preview.length > 0 &&
                    state.preview.map((item, idx) => (
                      <img
                        key={idx}
                        className={styles.preview}
                        src={item}
                        alt="미리보기"
                      />
                    ))}
                </div>
                <input
                  ref={fileRef}
                  type="file"
                  accept=".png,image/png"
                  className={styles.mainInput}
                  onChange={(e) => {
                    fileChange(e);
                  }}
                  multiple
                />
                <div className={styles.imageArea}>
                  {state.preview.length === 0 && (
                    <div className={styles.uploadIcon} />
                  )}
                  {state.preview.length > 0 && (
                    <button className={styles.cancelBtn} onClick={removeImage}>
                      <span className={styles.cancel}>X</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.registerButtonArea}>
          <button className={styles.registerButton} onClick={upsert}>
            <span className={styles.register}>수정</span>
          </button>
        </div>
        <Footer />
      </div>
    </div>
  );
}
